<template>
  <!-- 移动注册 -->
  <div class="register-wrap">
    <p class="register-title">注册</p>
    <div class="register-btn">
      <a class="register-btn-a" href="//web.etiantian.com/ett20/study/usermanage/studentregister.jsp" target="_blank">
      <!-- <a class="register-btn-a" href="https://gw1.bj.etiantian.com:15280/ett20/study/usermanage/studentregister.jsp" target="_blank"> -->
        <img src="../../assets/images/login/zc_photo.png" alt="">
        <p>学生</p>
      </a>
    </div>
    <div class="other-btn">
      <span>已有账号？</span>
      <span class="to-login" @click="goLogin">马上登录</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    goLogin() {
      let url = this.$router.resolve({
        path: '/mlogin'
      })
      window.open(url.href, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.register-wrap {
  width: 100%;
  min-height: 100vh;
  background: #fff;
  font: .28rem/1.5 "Microsoft Yahei", tahoma, Srial, helvetica, sans-serif;
  padding: 1.5rem .72rem 0;
  .register-title {
    display: inline-block;
    font-size: .6rem;
    font-weight: bold;
    color:rgba(33,124,254,1);
    line-height: .6rem;
    border-bottom: .14rem solid rgba(255,129,86,1);
  }
  .register-btn {
    margin-top: 1.56rem;
    font-size: .3rem;
    color: #FF8156;
    text-align: center;
    &-a {
      display: inline-block;
      img {
        width: 1.84rem;
        height: 1.84rem;
        border-radius: 50%;
        border: .08rem solid #FF8156;
      }
      p {
        line-height: .98rem;
      }
    }
  }
  .other-btn {
    text-align: center;
    font-size: .28rem;
    color: rgba(79,79,79,1);
    line-height: .28rem;
    margin-top: 1.8rem;
    font-weight: 500;
    .to-login {
      color: #217CFE;
      cursor: pointer;
    }
  }
}
</style>